import { ThemeColors } from '~/themes/colors'

export interface ExtensionPromptColors {
  Background: ThemeColors
  TitleFontColor: ThemeColors
  ScrollingList: {
    Item: {
      TitleFontColor: ThemeColors
      SubtitleFontColor: ThemeColors
    }
  }
}

export const extensionPromptColors: ExtensionPromptColors = {
  Background: {
    default: 'white',
  },
  TitleFontColor: {
    default: 'gray.900',
  },
  ScrollingList: {
    Item: {
      TitleFontColor: {
        default: 'gray.900',
      },
      SubtitleFontColor: {
        default: 'gray.800',
      },
    },
  },
}
